if (!customElements.get("reviews-slider")) {
    customElements.define(
      "reviews-slider",
      class ReviewSlider extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
            this.slider = this.querySelector('.review__slider');
            this.swiper = null;
            this.enabledReadMore = this.getAttribute('data-read-more');
            console.log(this.slider)

            if(this.slider){
                this.innitSlider();
            }
            if(this.enabledReadMore == 'true'){
                this.handleReadMoreButtons();
            }
        }
  
        disconnectedCallback() {

        }
  
        innitSlider(){
             this.swiper = new Swiper(this.slider,{
                slidesPerView: 1.3,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                speed: 500,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                        768: {
                            slidesPerView: 2.3,
                            slidesOffsetBefore: 48,
                            slidesOffsetAfter: 48
                        },
                        900: {
                            slidesPerView: 3.3,
                            slidesOffsetBefore: 48,
                            slidesOffsetAfter: 48
                        },
                        1060: {
                            slidesPerView: 4.35,
                            spaceBetween: 24,
                            slidesOffsetBefore: 48,
                            slidesOffsetAfter: 48
                        }
                }
            });
        }


        handleReadMoreButtons() {
            const items = this.querySelectorAll('.review__item-text-wrapper');
          
            items.forEach(wrapper => {
              const textEl = wrapper.querySelector('.review__item-text');
              const btn = wrapper.querySelector('.review__read-more-btn');
          
              if (!textEl || !btn) return;
          
              const isClamped = textEl.scrollHeight > textEl.offsetHeight + 1;
          
              if (!isClamped) {
                btn.style.display = 'none';
                return;
              }
          
              btn.addEventListener('click', () => {
                const isExpanded = textEl.classList.toggle('is-expanded');
                btn.textContent = isExpanded ? 'Weniger anzeigen' : 'Mehr lesen';
              });
            });
        }
        
      }
    );
  }
  